import { Container, delayedCall, dispatcher, ingenuity, ITween, killDelayedCall, SpineBase } from "@quest/base-core";
import { HoldAndRespinModel } from "../Model/HoldAndRespinModel";
import { HoldAndRespinView } from "../View/HoldAndRespinView";
import { Emitter, Quadratic } from "@quest/pixi-bridge";
import { EventConstants as platformEventConstants } from "@quest/platform-murka-phase_2/dist";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { GameParserModel } from "../../Platform/GameParserModel";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
export class WinCollectionTrailController {
  private readonly view: HoldAndRespinView;
  protected model: HoldAndRespinModel;
  private reelsTrailContainer: Container;
  private readonly winMeterHit: number[] = [420, 510];
  private readonly collectionBtnHit: number[] = [860, -80];
  private trailsDataArray: any = [];
  private collectionBlastAnim: SpineBase;

  private readonly getPosForFish: any = {
    4: [65, 50],
    6: [65, 84],
    9: [140, 110],
    12: [140, 150],
    16: [200, 150],
    20: [200, 200],
  };
  constructor(view: HoldAndRespinView, model: HoldAndRespinModel) {
    this.view = view;
    this.model = model;
    this.subscribeEvents();
    this.initializeElements();
  }
  private initializeElements(): void {
    this.reelsTrailContainer = this.view.getContainerByID("lighteningTrailReelsContainer");
    this.collectionBlastAnim = this.view.getSpineById("collection_btn_blast");
  }
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_WIN_COLLECTION_TRAIL, this.calculateWinningTrail, this);
    dispatcher.on(eventDispatchers.SHOW_TRAIL_TO_COLLECTION, this.showTrailToCollection, this);
  }
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_WIN_COLLECTION_TRAIL, this.calculateWinningTrail, this);
    dispatcher.off(eventDispatchers.SHOW_TRAIL_TO_COLLECTION, this.showTrailToCollection, this);
  }
  /**
   * to show moving symbol for auto pilot bait
   */
  private calculateWinningTrail(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstantGame.LL_ICON_WIN,
      vol: 1,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    (ingenuity.parserModel as GameParserModel).getAwardedBigFishes().forEach((data: any) => {
      const startX = data.start_col * this.view.json.symWidth + this.getPosForFish[data.size][0];
      const startY = data.start_row * this.view.json.symHeight + this.getPosForFish[data.size][0];
      this.showBubbleTrailEffect(startX, startY, this.winMeterHit[0], this.winMeterHit[1], true);
    });
    delayedCall(
      "showWinMeterHitAnim",
      1400,
      () => {
        killDelayedCall("showWinMeterHitAnim");
        this.resetTrails();
        dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
      },
      this
    );
  }
  //start trail from fihses to collection button
  private showTrailToCollection(): void {
    (ingenuity.parserModel as GameParserModel).getAwardedBigFishes().forEach((data: any) => {
      const startX = data.start_col * this.view.json.symWidth + this.getPosForFish[data.size][0];
      const startY = data.start_row * this.view.json.symHeight + this.getPosForFish[data.size][0];
      this.showBubbleTrailEffect(startX, startY, this.collectionBtnHit[0], this.collectionBtnHit[1], false);
    });
    delayedCall(
      "showWinMeterHitAnim",
      1400,
      () => {
        killDelayedCall("showWinMeterHitAnim");
        this.collectionBlastAnim.visible = true;
        this.collectionBlastAnim.playAnim("collect_effect", false);
        this.collectionBlastAnim.onComplete.addOnce(() => {
          delayedCall(
            "showNextPresentationsAfterDelay",
            100,
            () => {
              killDelayedCall("showNextPresentationsAfterDelay");
              dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
            },
            this
          );
          this.collectionBlastAnim.visible = false;
        });
        this.resetTrails();
      },
      this
    );
  }

  // starting point for spine , contaner and trail
  private showBubbleTrailEffect(
    row: number,
    col: number,
    finalX: number,
    finalY: number,
    showMeterBlast: boolean
  ): void {
    const movingContainer = this.createMovingContainer(row, col);
    this.initializeTrailEmmiterEffect(movingContainer, row, col, finalX, finalY, showMeterBlast);
  }
  /**
   * to create spine symbol
   * */
  private createMovingContainer(row: number, col: number): Container {
    const movingContainer: Container = this.view.createContainerClone("fishWinTrail");
    movingContainer.name = "fishWinTrail" + "_" + row + "_" + col;
    this.reelsTrailContainer.addChild(movingContainer);
    return movingContainer;
  }

  // initializse trail config
  private initializeTrailEmmiterEffect(
    movingContainer: Container,
    row: number,
    col: number,
    finalX: number,
    finalY: number,
    showMeterBlast: boolean
  ): void {
    const particleData: any = {
      emitterType: 0,
      id: "winCoinEmitter",
      autoStart: false,
      image: "particle",
    };
    const config: any = {
      alpha: {
        start: 1,
        end: 0.5,
      },
      scale: {
        start: 0.8,
        end: 0.2,
        minimumScaleMultiplier: 1,
      },
      color: {
        start: "#e3f9ff",
        end: "#ffffff",
      },
      speed: {
        start: 0,
        end: 0,
        minimumSpeedMultiplier: 1,
      },
      acceleration: {
        x: 0,
        y: 0,
      },
      maxSpeed: 0,
      lifetime: {
        min: 0.3,
        max: 0.4,
      },
      blendMode: "add",
      frequency: 0.001,
      emitterLifetime: -1,
      maxParticles: 1000,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    particleData.id = movingContainer.name;
    const glowTrail = ingenuity.currentGame.add.emitter(movingContainer, particleData, config) as Emitter;
    glowTrail.autoUpdate = true;
    glowTrail.emit = true;
    this.trailsDataArray.push(glowTrail);
    glowTrail.updateOwnerPos(row, col);
    this.playLightEffectTrail(glowTrail, row, col, finalX, finalY, showMeterBlast);
  }
  //to play light effect trail
  protected playLightEffectTrail(
    glowTrail: any,
    row: number,
    col: number,
    finalX: number,
    finalY: number,
    showMeterBlast: boolean
  ): void {
    const trailConfigs: any = {
      startX: row,
      startY: col,
      endX: finalX,
      endY: finalY,
      domeAmplitude: 40,
      zigzagAmplitude: 30,
      numPoints: 100,
      zigzagFrequency: 2,
      zigzagFadeOutRatio: 0.28,
    };
    let points: number[][] = this.addZigzagThenStraightCurve(
      trailConfigs.startX,
      trailConfigs.startY,
      trailConfigs.endX,
      trailConfigs.endY,
      trailConfigs.domeAmplitude,
      trailConfigs.zigzagAmplitude,
      trailConfigs.numPoints,
      trailConfigs.zigzagFrequency,
      trailConfigs.zigzagFadeOutRatio
    );

    let glowTrailTween: ITween;
    glowTrailTween = ingenuity.currentGame.add.tween(glowTrail.ownerPos);
    glowTrailTween.to({ x: points[0], y: points[1] }, 1300, Quadratic.In, true);

    glowTrailTween.onComplete.addOnce(() => {
      if (showMeterBlast) {
        dispatcher.fireEvent(eventDispatchers.PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER);
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
        dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, {
          value:
            (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() +
            (ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin()
        });
      }
    }, this);
  }
  // function will find the points in a manner where a trail first goes zig zag then suddenly goes straight
  private addZigzagThenStraightCurve(
    startX: number,
    startY: number,
    endX: number,
    endY: number,
    domeAmplitude: number,
    zigzagAmplitude: number,
    numPoints: number,
    zigzagFrequency: number,
    zigzagPortion: number
  ): number[][] {
    const xCoords: number[] = [];
    const yCoords: number[] = [];
    const deltaX = (endX - startX) / (numPoints - 1);
    const deltaY = (endY - startY) / (numPoints - 1);
    const pathAngle = Math.atan2(deltaY, deltaX);
    const perpendicularAngle = pathAngle + Math.PI / 2;
    const zigzagCutoff = Math.floor(numPoints * zigzagPortion);
    for (let i = 0; i < numPoints; i++) {
      const t = i / (numPoints - 1);
      const baseX = startX + t * (endX - startX);
      const baseY = startY + t * (endY - startY);
      let finalX = baseX;
      let finalY = baseY;
      if (i <= zigzagCutoff) {
        const localT = i / zigzagCutoff;
        const dome = Math.sin(Math.PI * localT);
        const offsetX = domeAmplitude * dome * Math.cos(perpendicularAngle);
        const offsetY = domeAmplitude * dome * Math.sin(perpendicularAngle);
        const zigzag = Math.sin(zigzagFrequency * Math.PI * localT);
        const xZigzag = zigzagAmplitude * zigzag;
        finalX += offsetX + xZigzag;
        finalY += offsetY;
      }
      xCoords.push(finalX);
      yCoords.push(finalY);
    }
    return [xCoords, yCoords];
  }
  // reset all containers and trail data
  private resetTrails(): void {
    this.trailsDataArray.forEach((em: any) => {
      em.autoUpdate = false;
      em.emit = false;
      em?.destroy();
    });
    this.reelsTrailContainer.children.forEach((cont: any) => {
      cont.removeChildren();
      cont.children = [];
    });
    this.reelsTrailContainer.removeChildren();
    this.reelsTrailContainer.children = [];
    this.trailsDataArray = [];
    ingenuity.currentGame.tweens.removeFrom(this);
  }
  //reset controllers and destroy everything
  public resetController(): void {
    this.resetTrails();
    this.unSubscribeEvents();
  }
}
